/* RESPONSIBLE TEAM: team-omni */
import SettingsRoute from 'embercom/routes/apps/app/settings/base/base-settings-route';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type Transition from '@ember/routing/-private/transition';
import { ReactRoute } from 'embercom/lib/react-route';

class DiscordRoute extends SettingsRoute {
  @service declare permissionsService: $TSFixMe;
  @service declare appService: $TSFixMe;
  @service declare intercomEventService: $TSFixMe;
  @service declare intl: IntlService;
  @service declare store: $TSFixMe;

  reactEnabled() {
    return true;
  }

  get titleToken() {
    return this.intl.t('new-settings.channels.discord.title');
  }

  async beforeModel(transition: Transition) {
    super.beforeModel(transition);
    return this.permissionsService.ensurePermissionWhenTransitioning(
      'can_access_product_settings',
      transition,
    );
  }

  async model() {
    return {
      settings: {},
    };
  }
}

export default ReactRoute(DiscordRoute);
